import type { PropsWithChildren } from 'react';
import React, { useRef } from 'react';
import { ADDITIONAL_QUERY_PARAMS_WHITE_LIST } from '@makemydeal/dr-shared-components';
import { initSessionToggles, persistSearchParams, useAppRouter } from '@makemydeal/dr-sales-checkin-ui-utils';

// This component will be removed once we start getting complete url from the bridge
const QueryParamsHandler: React.FC<PropsWithChildren> = ({ children }) => {
    const { search } = useAppRouter();
    const hasProcessedRef = useRef(false);
    const persistedDealXgIdRef = useRef<string | null | undefined>(undefined);

    // Process query params synchronously during render (before child effects run)
    // This ensures bffEnv is in session storage BEFORE Bootstrapper dispatches initialLoad()
    if (!hasProcessedRef.current) {
        hasProcessedRef.current = true;
        initSessionToggles(window.location.href, ADDITIONAL_QUERY_PARAMS_WHITE_LIST);
    }

    const dealXgId = new URLSearchParams(search).get('dealXgId');
    if (persistedDealXgIdRef.current === undefined || dealXgId !== persistedDealXgIdRef.current) {
        persistedDealXgIdRef.current = dealXgId;
        persistSearchParams(search);
    }

    return <>{children}</>;
};

export default QueryParamsHandler;
